module.exports = __webpack_public_path__ + "img/banner_2000.a83006f8.jpg";